import { render } from "./OrderLinkBadge.vue?vue&type=template&id=8565ae3c&scoped=true&ts=true"
import script from "./OrderLinkBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderLinkBadge.vue?vue&type=script&setup=true&lang=ts"

import "./OrderLinkBadge.vue?vue&type=style&index=0&id=8565ae3c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8565ae3c"],['__file',"resources/js/vue/domain/invoice/components/shared/OrderLinkBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8565ae3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8565ae3c', __exports__)) {
    api.reload('8565ae3c', __exports__)
  }
  
  module.hot.accept("./OrderLinkBadge.vue?vue&type=template&id=8565ae3c&scoped=true&ts=true", () => {
    api.rerender('8565ae3c', render)
  })

}


export default __exports__